import { render } from "./SMenu.vue?vue&type=template&id=39ab552a"
import script from "./SMenu.vue?vue&type=script&lang=js"
export * from "./SMenu.vue?vue&type=script&lang=js"

import "./SMenu.vue?vue&type=style&index=0&id=39ab552a&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__